import type { LucideIcon } from 'lucide-react';
import { CountUp } from './CountUp';

/**
 * Tarjeta KPI reutilizable (con gradiente de marca + count-up). Si recibe
 * `onClick`, se comporta como botón accesible (drill-down).
 */
export interface KpiCardProps {
  label: string;
  value: number;
  format: (n: number) => string;
  /** Gradiente Tailwind (`from-… via-… to-…`). */
  gradient: string;
  Icon: LucideIcon;
  hint?: string;
  onClick?: () => void;
}

export function KpiCard({ label, value, format, gradient, Icon, hint, onClick }: KpiCardProps) {
  const interactive = Boolean(onClick);
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!interactive}
      className={`flex flex-col gap-1 rounded-2xl bg-gradient-to-br ${gradient} p-4 text-left text-white shadow-md transition ${
        interactive ? 'hover:scale-[1.02] hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-white/60' : 'cursor-default'
      }`}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold text-white/80">{label}</span>
        <Icon className="h-4 w-4 text-white/80" />
      </div>
      <span className="text-2xl font-black tracking-tight">
        <CountUp value={value} format={format} />
      </span>
      {hint && <span className="text-[11px] font-medium text-white/70">{hint}</span>}
    </button>
  );
}
